export default __webpack_public_path__ + "static/media/register6.61d3a3e8.jpg";